import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Api, getSentInvitations, InvitationResponseDto } from '@taxora-api';
import { LoadInvitations } from './invitations.actions';

interface InvitationsStateModel {
  invitations: InvitationResponseDto[];
  isLoading: boolean;
}

@State<InvitationsStateModel>({
  name: 'accountantInvitations',
  defaults: { invitations: [], isLoading: false },
})
@Injectable()
export class InvitationsState {
  private readonly api = inject(Api);

  @Selector()
  static invitations(state: InvitationsStateModel): InvitationResponseDto[] {
    return state.invitations;
  }

  @Selector()
  static isLoading(state: InvitationsStateModel): boolean {
    return state.isLoading;
  }

  @Action(LoadInvitations)
  async load(
    { patchState }: StateContext<InvitationsStateModel>,
    { organizationId }: LoadInvitations,
  ): Promise<void> {
    patchState({ isLoading: true });
    try {
      const result = await this.api.invoke(getSentInvitations, {
        organizationId,
        limit: 100,
      });
      patchState({ invitations: result.data });
    } catch (error) {
      console.error('Failed to load sent invitations', error);
    } finally {
      patchState({ isLoading: false });
    }
  }
}
